<template>

  <div class="docai-main">

    <div class="header">
      <h1>Document AI</h1>
      <h2>{{test1}}</h2>
    </div>
<!-- <Table tableID="Test" tableTitle="Test data" :tableData="testData">
</Table> -->
    <div class="content">
      <button @click="testMeClicked('FORM','form')">Test Form Parser</button>
      <button @click="testMeClicked('OCR','ocr')">Test OCR</button>
      <!-- <Attachments class="testAttach" :data.sync="attachmentProp" :selectedAttachments="attachmentSelected" /> -->
      <div v-if="isLoading">Loading . . .</div>
      <Input textType="file" @fileChanged="attachmentAdd" />
      <div
      >Choose Page:
        <button style="margin-right: 3px" v-for="(p, ind) in pages" :key="p" @click="pageClicked(ind)">{{ ind + 1 }}</button>
      </div>
      <div class ="container">
        <div class ='img'>
          <iframe v-if="pdfLink" :src="pdfLink" id="iframe" frameborder="0" width="700px" height="750px"></iframe>
        </div>
        <div v-if="this.test=='OCR'"> {{response}} </div>
        
        <div v-else-if="this.test=='FORM'" class ='text'>
          <div v-for="f in allFields" :key="f">
          {{ f['key'] }} : {{ f['value'] }}
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
/* eslint-disable */
  import Attachments from '@/components/tabComponents/Attachments.vue';
  import Input from '@/components/Input.vue';
  import Loader from '@/components/Loader.vue';

  export default {
  data(){
  return{
  test1: "Please select document(s) to upload"
  }

  },
  components:{
    Attachments, Input, Loader
  },
  props:{
    attachmentProp: {type: Object, default: function() { return null } },
    attachmentPropBase64: {type: String, default: '' },
    response: {type: String, default:'' },
    //extractedData:{ type: Object, default: function() { return null } },
    pdfLink: {type: String, default: '' },
    isLoading: { type: Boolean, default: false },
    allFields: {type: Array, default: function() { return [] } },
    pages: { type: Array, default: function() { return [] } },
    test: { type: String, default: "" },
    //test2:{ type: Array, default: function() { return [] }}
    //testData: { type: Array, default: function() { return [{"Name":"Jolyn", "Age":23},{"Name":"Jolyn", "Age":21}]}}
  },
  mounted() {
    this.$bus.$on('attachmentsAdded', this.attachmentAdd);
    //this.compClicked();
  },
  methods:{

    // compClicked: function (e) {
    //     var testData = 'AMOUNT OF WAGES FOR THE MONTH RATE OF CONTRIBUTION FOR THE MONTH By the Employer By the Total Employee Contribution RM RM RM RM RM From 1,240.01 to 1,260.00 164.00 114.00 278.00 From 1,260.01 to 1,280.00 167.00 116.00 283.00 From 1,280.01 to 1,300.00 169.00 117.00 286.00 From 1,300.01 to 1,320.00 172.00 119.00 291.00 From 1,320.01 to 1,340.00 175.00 121.00 296.00 From 1,340.01 to 1,360.00 177.00 123.00 300.00 From 1,360.01 to 1,380.00 180.00 125.00 305.00 From 1,380.01 to 1,400.00 182.00 126.00 308.00 From 1,400.01 to 1,420.00 185.00 128.00 313.00 From 1,420.01 to 1,440.00 188.00 130.00 318.00 From 1,440.01 to 1,460.00 190.00 132.00 322.00 From 1,460.01 to 1,480.00 193.00 134.00 327.00 From 1,480.01 to 1,500.00 195.00 135.00 330.00 From 1,500.01 to 1,520.00 198.00 137.00 335.00 From 1,520.01 to 1,540.00 201.00 139.00 340.00 From 1,540.01 to 1,560.00 203.00 141.00 344.00 From 1,560.01 to 1,580.00 206.00 143.00 349.00 From to 1,600.00 208.00 144.00 352.00 From to 1,620.00 211.00 146.00 357.00 From to 1,640.00 214.00 148.00 362.00 From 1,580.01 1,600.01 1,620.01 1,640.01 1,660.01 1,680.01 1,700.01 to 1,660.00 216.00 150.00 366.00 From to 1,680.00 219.00 152.00 371.00 From to 1,700.00 221.00 153.00 374.00 From to 1,720.00 224.00 155.00 379.00 From 1,720.01 to 1,740.00 227.00 157.00 384.00 From 1,740.01 to 1,760.00 229.00 159.00 388.00 From 1,760.01 to 1,780.00 232.00 161.00 393.00 PAGE END';
    //     var from = testData.split('From');
    //     from.splice(0, 1);
    //     var formatted = from.map((f) => {
    //       var result = f.trim().split(' ');
    //       var toIndex = result.indexOf('to');
    //       result.splice(toIndex, 1);
    //       return result;
    //     });
        
    //     var finalResult = [];
    //     var errorResult = [];
    //     formatted.forEach((f) => {
    //       if (f.length == 5) {
    //         finalResult.push({
    //           minValue: f[0],
    //           maxValue: f[1],
    //           employer: f[2],
    //           employee: f[3],
    //           total: f[4]
    //         });
    //       } else {
    //         errorResult.push(f);
    //       }
    //     });
    //     // console.log(formatted);
    //     console.log(finalResult);
    //     console.log(errorResult);
    //     return;
    //   },

    testMeClicked: async function(type, clicked) {
      if (clicked === "ocr")
      {
        this.test = "OCR";
        
      }else if (clicked === "form") {
        this.test = "FORM";
      }
      

      if (!this.attachmentProp) {
          return;
        }

      this.extractedData = null;
      this.allFields = [];

      var data = {
          "document": {
            "mimeType": this.attachmentProp['type'],
            "content": this.attachmentPropBase64,
          }
        };
      console.log(data);
      alert(clicked);

      console.log('Start');
      this.isLoading = true;
      var result = await this.$apiCallV2(`/DocumentAi/DocumentOCR?apiType=${type}`, data);
      this.isLoading = false;
      console.log(result.data);
      this.response = result.data['document']['text'];
      data="";

      // removes all unwanted characters in the string
       var rawDatas = this.response.split(/[↵\s]/);
       //console.log(this.rawDatas);

      // finds the index value (position) of element ("From") in the list
      var index = rawDatas.findIndex(element => element === "From");

      // removes all the unwanted elements from the array
      var datas = rawDatas.slice(index);

      // console.log("datas:\n" + datas);

      // finds the number of rows needed to the 2D array (table)
      var rows = 0;
      for (let index = 0; index < datas.length; index++) {
          if (datas[index] === "From") {
              rows++;
          }
      }

      

       // finds the number of columns needed to the 2D array (table)
      var columns = -1;
      var frequency = 0;
      var n_index = 0;
      while (n_index < datas.length && frequency <= 1) {
          if (datas[n_index] === "From") {
              frequency++;
          }
          columns++;
          n_index++;
      }


      // inserts all the relevant data from the 1D array
      // into the 2D array (table)
      var myTable = []
      var k_index = 0
      for (let row = 0; row < rows; row++) {
          var newRow = []
          for (let column = 0; column < columns; column++) {
              newRow.push(datas[k_index]);
              k_index++;
          }
          myTable.push(newRow);
      }

      var array=[];
      // // displays all values
      for (let row = 0; row < myTable.length; row++) {
          var a ="row " + row + ".\t" + myTable[row];
          array.push(a);
      }

      console.log(array);
      this.pages = result.data['document']['pages'];

      var blob = new Blob([this.attachmentProp], { type: this.attachmentProp['type'] });
      var url = window.URL.createObjectURL(blob, { oneTimeOnly: false });
      var link = document.createElement('a');
      //link.href = url;
      this.pdfLink = url;
      this.pageClicked(0);
      //await this.$apiCallV2(`/JolynTest/GetProcessingResult2?file=${obj['content']}&mime=${obj['mimeType']}`);
    },
    pageClicked: function(page) {
        this.allFields = [];
        this.pages[page]['formFields'].forEach((f) => {
          // Key
          var key = f['fieldName']['textAnchor']['textSegments'][0];

          var keyText = '';
          var keyStart = 0;
          var keyEnd = 0;

          if (key['startIndex']) {
            keyStart = parseInt(key['startIndex']);
          }
          keyEnd = parseInt(key['endIndex']);
          keyText = this.response.substring(keyStart, keyEnd);
          // Key

          // Value
          var val = f['fieldValue']['textAnchor']['textSegments'][0];

          var valText = '';
          var valStart = 0;
          var valEnd = 0;

          if (val['startIndex']) {
            valStart = parseInt(val['startIndex']);
          }
          valEnd = parseInt(val['endIndex']);
          valText = this.response.substring(valStart, valEnd);
          // Value

          this.allFields.push({
            key: keyText.replace(':', '').trim(),
            value: valText.trim()
          });
        });
      },
    attachmentAdd: function(attachment, placeholder) {
      this.attachmentProp = attachment[0];
      var reader = new FileReader();
      reader.readAsDataURL(this.attachmentProp);
      reader.onload = () => {
        this.attachmentPropBase64 = reader.result.split(',')[1];
        console.log(this.attachmentPropBase64);
      };
    },
  },
}
</script>


<style lang="scss" scoped>
@import '@/css/all.scss';

.container {
  width: 100%;
  height: 100%;
  display: flex;
}

.img {
  width: 100%;
  height: 100%;
  float: left;
}

.text {
  float:right;
}

.docai-main {
  width: 100%;
  height: 100%;
  // background-color: yellow;
  padding: 5px 45px;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
}

.header {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
}

.header h1 {
  font-weight: bold;
}

.header h2 {
  font-size: 14px;
}

.content {
  width: 100%;
  height: auto;
  flex: 1;
  border: solid 1px red;
}

.testAttach {
  width: 800px;
  min-width: 800px;
  height: 600px;
  border: solid 1px hotpink;
}


</style>